import { Ripple } from "@/shared/ui/Ripple";

import { BaseController } from "@/app/controller/BaseController";
import { trans } from "@/app/localization/Trans";

export class HelpController extends BaseController {
    public onGoBack?: { () };
    public onRate?: { () };
    public onReportIssue?: { () };

    constructor() {
        super("help");

        const hdr = $('<div class="head"><div class="title">' + trans.help.helpTitle + "</div></div>").appendTo(
            this.$view
        );
        Ripple.bind($('<a class="action left" href="#"><i class="fal fa-arrow-left"></i></a>'))
            .prependTo(hdr)
            .click((e) => {
                e.preventDefault();
                if (this.onGoBack !== undefined) this.onGoBack();
            });

        const scrollable = $('<div class="scrollable" />').appendTo(this.$view);
        scrollable.append(
            '<div class="lead"><b>' + trans.help.helpLead + "</b><p>" + trans.help.helpText + "</p></div>"
        );

        const subMenu = $('<div class="navlinks" />').appendTo(scrollable);
        $(
            '<div class="navlink"><div class="icon"><i class="fal fa-star"></i></div><div class="lbl">' +
                trans.help.rateTastierBtn +
                '</div><i class="fal fa-long-arrow-alt-right"></i></div>'
        )
            .appendTo(subMenu)
            .click((e) => {
                $(e.currentTarget).addClass("selected");
                if (this.onRate !== undefined) this.onRate();
            });

        $(
            '<div class="navlink"><div class="icon"><i class="fal fa-comments"></i></div><div class="lbl">' +
                trans.help.reportProblemBtn +
                '</div><i class="fal fa-long-arrow-alt-right"></i></div>'
        )
            .appendTo(subMenu)
            .click((e) => {
                $(e.currentTarget).addClass("selected");
                if (this.onReportIssue !== undefined) this.onReportIssue();
            });

        const bottom = $('<div class="bottom" />').appendTo(this.$view);
        const contact = $('<div class="contact" />').appendTo(bottom);
        contact.append('<a href="tel:+41 76 784 44 68"><i class="fas fa-phone-flip"></i>+41 76 784 44 68</a>');
        contact.append('<a href="mailto:feedback@tastier.ch"><i class="fas fa-envelope"></i> feedback@tastier.ch</a>');

        const links = $('<div class="links" />').appendTo(bottom);
        links.append('<a href="https://www.tastier.ch/legal-de/" target="_blank" class="left">Terms & Conditions</a>');
        links.append('<span class="separator"></span>');
        links.append(
            '<a href="https://www.tastier.ch/dataprivacy-de/" target="_blank" class="right">Privacy Policy</a>'
        );
    }

    protected onBecomeVisible() {
        this.$view
            .find(".navlinks > .navlink.selected")
            .delay(300)
            .queue(function (this: any, e) {
                $(this).removeClass("selected");
                e();
            });
    }

    protected onBecomeInvisible() {}
}
